import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../api';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isAdminRole, setIsAdminRole] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  function refresh() {
    api.listUsers().then(setUsers).catch(() => toast.error("Couldn't load users."));
  }

  useEffect(refresh, []);

  async function handleCreate(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.createUser(name, email, password, isAdminRole ? 'admin' : 'user');
      toast.success('User created');
      setName('');
      setEmail('');
      setPassword('');
      setIsAdminRole(false);
      setShowForm(false);
      refresh();
    } catch {
      toast.error("Couldn't create the user — check the email isn't already in use.");
    } finally {
      setSubmitting(false);
    }
  }

  async function toggleActive(user) {
    try {
      await api.setUserActive(user.id, !user.is_active);
      refresh();
    } catch {
      toast.error("Couldn't update that user.");
    }
  }

  return (
    <div className="page">
      <h1>Manage users</h1>
      <button onClick={() => setShowForm((v) => !v)}>{showForm ? 'Cancel' : 'Add user'}</button>

      {showForm && (
        <form className="card" onSubmit={handleCreate}>
          <label>
            Name
            <input value={name} onChange={(e) => setName(e.target.value)} required />
          </label>
          <label>
            Email
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label>
            Temporary password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={isAdminRole}
              onChange={(e) => setIsAdminRole(e.target.checked)}
            />
            Admin
          </label>
          <button type="submit" disabled={submitting}>
            {submitting ? 'Adding…' : 'Add'}
          </button>
        </form>
      )}

      <ul className="user-list">
        {users.map((u) => (
          <li key={u.id} className="user-row">
            <div>
              <div className="task-title">{u.name}</div>
              <div className="hint">{u.email} · {u.role}</div>
            </div>
            <button onClick={() => toggleActive(u)}>
              {u.is_active ? 'Deactivate' : 'Activate'}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
